import { useState, useEffect } from "react";
import { GlossaryBlueprint } from "../../../types-games";

import { GlossarySectionForm } from "./ObjectSectionForm";
import { AVAILABLE_FIELDS } from "@/lib/utils/fieldDefinitions";
import { GlossaryItem, sectionDataObject } from "@/lib/stores/objectsStore";
import { useSelectedGameUsers} from "@/lib/useSelectedGameUsers";
import { BlueprintVersionChanges } from "@/lib/utils/blueprintVersionUtils";

import { usePlatformTranslation } from '@/hooks/usePlatformTranslation';
interface GlossaryBlockFormProps {
  blueprint?: GlossaryBlueprint;
  initialData?: ObjectItem;
  onCancel?: () => void;
  onFormDataChange?: (updates: Record<string, any>) => void;
  // Add new props
  sections: sectionDataObject[];
  onSectionsChange: (sections: sectionDataObject[]) => void;
  mode?: "create" | "edit" | "view"; // Add this prop
  canEdit?: boolean; // Whether user can edit (controls field locking)
  blueprintChanges?: BlueprintVersionChanges | null;
  showDocumentation?: boolean; // Whether to show documentation inline
}

export const GlossaryBlockForm = ({
  blueprint: propBlueprint,
  sections,
  onSectionsChange,
  mode = "create", // Add this prop with default
  canEdit = true, // Default to true for backwards compatibility
  blueprintChanges,
  showDocumentation = false,
}: GlossaryBlockFormProps) => {
  const { t } = usePlatformTranslation();
  const { selectedGame } = useSelectedGameUsers();
  const gameId = selectedGame?.id;

  // Add safety check for sections
  if (!sections || sections.length === 0) {
    return (
      <div className="flex items-center justify-center p-8">
        <div className="text-muted-foreground">{t('platform.wizards.glossary.loading_form_sections')}</div>
      </div>
    );
  }

  const handleInputChange = (fieldId: string, value: any) => {
    // Update the field value in sections
    console.log("handleInputChange", fieldId, value);
    const updatedSections = sections.map(section => ({
      ...section,
      fields: section.fields.map(field => 
        field.id === fieldId ? { ...field, value } : field
      )
    }));
    
    onSectionsChange(updatedSections);

  };

  if (!propBlueprint) {
    return (
      <div className="flex items-center justify-center p-8">
        <div className="text-muted-foreground">{t('platform.wizards.glossary.loading_glossary_blueprint')}</div>
      </div>
    );
  }

  return (
    <div className="space-y-6 pb-8">
      {/* Sections Form */}
      <div className="space-y-4">
        <GlossarySectionForm
          sections={sections}
          onInputChange={handleInputChange}
          mode={mode} // Pass the mode down
          canEdit={canEdit} // Pass canEdit to control field locking
          gameId={gameId}
          blueprintChanges={blueprintChanges}
          showDocumentation={showDocumentation}
        />
      </div>
    </div>
  );
};
